'use server';

import { cookies } from 'next/headers';
import { LOCALE_COOKIE, isLocale } from './config';

/**
 * Server action used by the language switcher.
 * Sets the NEXT_LOCALE cookie; the next request will see the new locale.
 * The client is expected to call window.location.reload() after this
 * resolves so the new messages are loaded.
 */
export async function setLocaleCookie(value: string) {
  if (!isLocale(value)) return;
  const c = await cookies();
  c.set(LOCALE_COOKIE, value, {
    path: '/',
    httpOnly: false, // readable client-side for debugging
    sameSite: 'lax',
    // 1 year — locale is a long-term preference
    maxAge: 60 * 60 * 24 * 365,
  });
}
